import { Component, OnInit, Output, EventEmitter, Input } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { AuthService } from 'src/app/shared/auth/auth.service';
import { URLConst } from 'src/app/shared/const/url.const';
import { EnvironmentconfigService } from '../../../../shared/service/environmentconfig.service';
import { WebApiService } from 'src/app/shared/service/webapi.service';
import { NzMessageService } from 'ng-zorro-antd/message';
import { WMSM001Component } from 'src/app/WMSM-Pages/WMSM001/WMSM001.component';
import { WMSM002Component } from 'src/app/WMSM-Pages/WMSM002/WMSM002.component';
import { WmsmChangeHistoryComponent } from 'src/app/WMSM-Pages/wmsm-ChangeHistory/wmsm-ChangeHistory.component';
import { NzUploadFile } from 'ng-zorro-antd/upload';
import { TranslateService } from '@ngx-translate/core';

interface SiteDto {
  siteCode: string;
  // 其他属性...
}

@Component({
  selector: 'app-wmsm-conditions',
  templateUrl: './wmsm-conditions.component.html',
  styleUrls: ['./wmsm-conditions.component.scss'],
  providers: []
})


export class WmsmConditionsComponent implements OnInit {
  validateForm: FormGroup;
  SiteList: any;
  VendorList: any;
  BuyerList: any;
  DeptList: any;
  TypeList: any;
  UserRequestlimits: boolean = true;
  QuertStr: string;
  dateFormat = 'yyyy/MM/dd';
  monthFormat = 'yyyy/MM';
  selectedLabels: string[] = [];
  //從外部輸入
  @Input() QueryFromParent: string;

  //监听条件区数值改变，改变则往下传值
  @Output() listenForm = new EventEmitter();
  //实现查询时/点击时，条件区小三角形收缩
  @Input() isShowCondition: boolean;
  //user的权限控制
  @Input() show: boolean;
  //实现查询时/点击时，条件区小三角形收缩
  @Output() outQuery = new EventEmitter();
  loading: boolean = false;
  All: any;
  options = [
    { nzLabel: 'Installment', nzValue: 'I' },
    { nzLabel: 'Not-RT', nzValue: 'N' },
    { nzLabel: 'RT', nzValue: 'R' }
  ];
  //按需求控制三个条件区是否需要显示
  @Input() ShowSite: boolean = true;
  @Input() ShowVendor: boolean = true;
  @Input() ShowBuyer: boolean = true;
  @Input() ShowType: boolean = true;
  @Input() ShowPRNO: boolean = true;
  @Input() ShowSecondExport: boolean = false;
  @Input() ShowUpload: boolean = true;
  @Input() ShowSecondDownloadExcel: boolean = true;
  @Input() ShowPOApprovedate: boolean = true;
  // private wmsm001Component: WMSM001Component;

  constructor(
    private fb: FormBuilder,
    private AuthService: AuthService,
    private EnvironmentconfigService: EnvironmentconfigService,
    private WebApiService: WebApiService,
    private NzMessageService: NzMessageService,

    private deliveryScheduleMaintenanceService: WMSM001Component,
    private deliveryQueryService: WMSM002Component,
    private ChangeHistory: WmsmChangeHistoryComponent,
    private translate: TranslateService




  ) {

  }

  ngOnInit() {
    if (!this.show) {
      this.UserRequestlimits = false;
    }
    this.validateForm = this.fb.group(
      {
        Site: '',
        Vendor: [[]],
        Buyer: [[]],
        Type: [['I', 'R']],
        PONO: '',
        RTorNot: '',
        PRNO: '',
        POApprovedate: []
      }
    );
    this.GetConditions();

    setTimeout(() => {
      this.setInitialPOApprovedateValue();
    }, 0);
  }

  GetConditions(): Promise<void> {
    this.loading = true;
    const url = `${this.EnvironmentconfigService.authConfig.wmsmUrl}${URLConst.GetCondition.url}`;
    return new Promise((resolve, reject) => {
      this.WebApiService.doPost(url, '').subscribe(
        (res) => {
          if (res.data.siteListDto.length != 0) {
            this.SiteList = res.data.siteListDto.sort(this.compare);
            //   this.BuyerList = res.data.buyerListDto;
            // this.validateForm.controls['Buyer'].setValue(['ALL']);
            //this.validateForm.controls['Site'].setValue(this.SiteList[0].siteCode);
            // console.log(this.SiteList[0]);
            resolve();
            this.valuehandleChange();
          } else {
            this.translate.get('TemporaryUnconditionalZoneInformation').subscribe((translatedText: string) => {
              this.NzMessageService.error(translatedText);
            })
            reject()
          }
          this.loading = false;
        },
        (error) => {
          this.NzMessageService.error(error.msg);
          this.loading = false;
        }
      );
    })

  }



  setInitialPOApprovedateValue() {
    const today = new Date();
    let monthOffset = -3;

    if (this.QueryFromParent === 'ChangeHistory') {
      monthOffset = -1;
    }

    let month = today.getMonth() + monthOffset;
    let year = today.getFullYear();

    if (month < 0) {
      month += 12;
      year -= 1;
    }

    const oneMonthAgo = new Date(year, month, today.getDate());
    this.validateForm.controls['POApprovedate'].setValue([oneMonthAgo, today], { emitEvent: false });
    this.validateForm.controls['POApprovedate'].updateValueAndValidity();
  }

  checkDateRangeValidation() {
    debugger
    const dateRangeErrors = this.validateForm.get('POApprovedate')?.errors;
    if (dateRangeErrors && dateRangeErrors.dateRangeExceedsYear) {
      return this.translate.get('DateRangeCannotExceedOneYear').subscribe((translatedText: string) => {
        this.NzMessageService.error(translatedText);
      })
    }
  }


  valuehandleChanges(): void {
    let value = {};
    Object.keys(this.validateForm.controls).forEach((key) => {

      if (key === 'Site') {
        value[key] = this.validateForm.controls[key].value
      }
      else if (key === 'Buyer') {
        this.validateForm.controls[key].value.includes('ALL')
          ? (value[key] = this.BuyerList.map((item) => item.buyer))
          : (value[key] = this.validateForm.controls[key].value);
      }
      else {
        value[key] = this.validateForm.controls[key].value;
      }
    });
    this.listenForm.emit(value);
  }


  GetResDto(dept: any): Promise<void> {

    this.loading = true;
    const url = `${this.EnvironmentconfigService.authConfig.wmsmUrl}${URLConst.wmsm001GetResDto.url}`;
    const params = {
      data: {
        Type: '', //後端會重取
        SiteNo: '',
        SupList: dept,
      },
    };
    return new Promise((resolve, reject) => {
      this.WebApiService.doPost(url, params).subscribe(
        (res) => {
          if (
            res &&
            res.status == this.EnvironmentconfigService.authConfig.wmsmStatus
          ) {
            this.SiteList = res.data.siteListDto;
            this.VendorList = res.data.vendorListDto;
            this.BuyerList = res.data.buyerListDto;
            this.validateForm.controls['Site'].setValue(this.SiteList[0].site);
            this.validateForm.controls['Buyer'].setValue(['ALL']);
            resolve();
            this.valuehandleChange();
          } else {
            this.translate.get('TemporaryUnconditionalZoneInformation').subscribe((translatedText: string) => {
              this.NzMessageService.error(translatedText);
            })
            reject()
          }
          this.loading = false;
        },
        (error) => {
          this.NzMessageService.error(error.msg);
          this.loading = false;
        }
      );
    })

  }

  valuehandleChange(): void {
    let value = {};
    Object.keys(this.validateForm.controls).forEach((key) => {
      value[key] = this.validateForm.controls[key].value;
    });
    this.listenForm.emit(value);

    this.selectedLabels = this.validateForm.controls['Type'].value.map(value => {
      const option = this.options.find(option => option.nzValue === value);
      return option ? option.nzLabel : '';
    }).slice(1);
  }

  sendQuery() {
    let value = this.isShowCondition;
    this.outQuery.emit(value);
  }


  SiteChange() {
    // this.loading = true;
    // const url = `${this.EnvironmentconfigService.authConfig.wmsmUrl}${URLConst.GetResDtoDetail.url}`;
    // const params = {
    //   data: {
    //     Type: this.AuthService.userInfo.Role,
    //     SiteNo: this.validateForm.controls['Site'].value,
    //     SupList: [],
    //   },
    // };
    // this.WebApiService.doPost(url, params).subscribe(
    //   (res) => {
    //     if (
    //       res &&
    //       res.status == this.EnvironmentconfigService.authConfig.wmsmStatus
    //     ) {
    //       this.VendorList = res.data.vendorListDto;
    //       this.BuyerList = res.data.buyerListDto;
    //       this.AuthService.AllVendorList = res.data.vendorListDto;
    //       this.AuthService.AllBuyerList = res.data.buyerListDto;
    //       this.AuthService.defautSite = this.validateForm.controls['Site'].value;
    //       this.validateForm.controls['Buyer'].setValue(['ALL']);
    //       this.valuehandleChange()
    //     } else {
    //       this.NzMessageService.error(res.msg);
    //     }
    //     this.loading = false;
    //   },
    //   (error) => {
    //     this.NzMessageService.error(error.msg);
    //     this.loading = false;
    //   }
    // );
  }




  bindList() {
    if (this.AuthService.AllBuyerList || this.AuthService.AllVendorList || this.AuthService.AllDeptList || this.AuthService.AllSiteList) { // 有权限有值
      this.BuyerList = this.AuthService.AllBuyerList;
      this.VendorList = this.AuthService.AllVendorList;
      this.DeptList = this.AuthService.AllDeptList;
      this.SiteList = this.AuthService.AllSiteList;
      this.validateForm.controls['Site'].setValue(this.AuthService.defautSite);
      this.validateForm.controls['Vendor'].setValue(['ALL']);
      this.validateForm.controls['Buyer'].setValue(['ALL']);
      this.validateForm.controls['Dept'].setValue(['ALL']);
      this.valuehandleChange();
    } else { // 有权限没值
      this.GetResDto([])
    }
  }

  onPageChangeQuery() {
    if (this.QueryFromParent == 'deliveryScheduleMaintenanceService') {
      this.deliveryScheduleMaintenanceService.onSearch();
    }
    if (this.QueryFromParent == 'deliveryQueryService') {
      this.deliveryQueryService.onSearch();
    }
    if (this.QueryFromParent == 'ChangeHistory') {
      this.ChangeHistory.onSearch();
    }
  }

  onPageChangeDownload() {
    if (this.QueryFromParent == 'deliveryScheduleMaintenanceService') {
      this.deliveryScheduleMaintenanceService.exportTableToExecl();
    }
    if (this.QueryFromParent == 'deliveryQueryService') {
      this.deliveryQueryService.exportTableToExecl();
    }
    if (this.QueryFromParent == 'ChangeHistory') {
      this.ChangeHistory.exportTableToExecl();
    }
  }

  beforeUpload = (file: NzUploadFile): boolean => {
    if (this.QueryFromParent == 'deliveryScheduleMaintenanceService') {
      this.deliveryScheduleMaintenanceService.saveExcelData(file);
    }
    return false;
  };

  onPageChangeUploadExcel() {

  }


  optionListAll = []; // 定义从后台获取的select的option数据集合
  optionList = []; // 定义显示的select的option数据集合
  optionScrollPage = 1; // 全局变量定义option滚动的页数
  optionScrollSize = 200; // 全局变量定义option每页条数

  initOption(VendorData) {
    // ....省略获取 .....
    this.optionListAll = VendorData; //后台返回数据赋值给定义的变量
    this.optionScrollPage = 1;
    this.VendorList = this.optionListAll.slice((this.optionScrollPage - 1) * this.optionScrollSize, this.optionScrollPage * this.optionScrollSize); // slice截取不改变原数组
  }

  // 滚动到底部时，加载更多
  loadMore(): void {
    this.optionScrollPage++;
    this.VendorList = [...this.VendorList,
    ...this.optionListAll.slice((this.optionScrollPage - 1) * this.optionScrollSize, this.optionScrollPage * this.optionScrollSize)];
  }


  // select查询
  onOptionSearch(value: string): void {
    this.optionScrollPage = 1;
    if (!value) {
      this.VendorList = this.optionListAll.slice((this.optionScrollPage - 1) * this.optionScrollSize, this.optionScrollPage * this.optionScrollSize);
    } else {
      const list = [];
      this.optionListAll.forEach(item => {
        if (item.taxNumber.indexOf(value) >= 0) {
          list.push(item);
        }
      });
      this.VendorList = list.slice((this.optionScrollPage - 1) * this.optionScrollSize,
        this.optionScrollPage * this.optionScrollSize);
    }

  }



  VendorSearch(event) {
    if (event.length > 1) {
      const params = {
        Inputdata: event,
        SiteNo: this.validateForm.controls['Site'].value
      };
      const url = `${this.EnvironmentconfigService.authConfig.wmsmUrl}${URLConst.GetVendorListAsync.url}`;
      this.WebApiService.doPost(url, params).subscribe(
        (res) => {

          this.VendorList = res;
        },
        (error) => {
          this.NzMessageService.error(error.msg);
        }
      );
    }
  }

  BuyerSearch(event) {
    if (event.length > 2) {
      const params = {
        Inputdata: event,
        SiteNo: this.validateForm.controls['Site'].value
      };
      const url = `${this.EnvironmentconfigService.authConfig.wmsmUrl}${URLConst.GetBuyerListAsync.url}`;
      this.WebApiService.doPost(url, params).subscribe(
        (res) => {
          this.BuyerList = res
        },
        (error) => {
          this.NzMessageService.error(error.msg);
        }
      );
    }
  }

  compare(a: SiteDto, b: SiteDto): number {
    const nameA = a.siteCode.toUpperCase(); // 忽略大小写进行比较
    const nameB = b.siteCode.toUpperCase();

    if (nameA < nameB) {
      return -1;  // a 在 b 前面
    }
    if (nameA > nameB) {
      return 1;  // a 在 b 后面
    }
    return 0;  // 名称相同
  }


}
